<template>
  <!-- 行业资质  -->
  <div>
    <x-tabula
      ref="table"
      rowKey="qualifyId"
      :dataSource="dataSource"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="true"
      :deleteParam="deleteParam"
    >
      <template slot="opt_h" slot-scope="{row}">
        <a-tooltip :title="row.qualifyDesc">
          <div class="feed-over-text">{{row.qualifyDesc}}</div>
        </a-tooltip>
      </template>
    </x-tabula>
    <add-model ref='add'></add-model>
    <query-model ref='query'></query-model>
    <edit-model ref='edit'></edit-model>
  </div>
</template>

<script>
import addModel from './addModel.vue';
import queryModel from './queryModel.vue';
import editModel from './editModel.vue';
export default {
  name: 'industryQualifications',
  components: {addModel, queryModel, editModel},
  data () {
    return {
      searchList: [
        {
          props: ['categoryIds'],
          placeholder: '类目',
          options: [],
          inputType: 'treeSelectMultiple'
        },
        {
          props: ['status'],
          placeholder: '状态',
          options: [
            {label: '禁用', value: '0'},
            {label: '启用', value: '1'}
          ],
          inputType: 'select'
        }

      ],
      tableOptList: [
        {
          text: '新增',
          icon: 'plus',
          handle: () => { this.$refs.add.visible = true; },
          permi: ['community:localQualify:add']
        },
        {text: '删除', icon: 'close', disabled: true, permi: ['community:localQualify:remove'] }
      ],
      rowOptList: [
        {
          text: '查看',
          handle: (row) => { this.$refs.query.show(row); },
          key: '',
          permi: ['community:localQualify:query']
        },
        {
          text: '修改',
          handle: (row) => { this.$refs.edit.show(row); },
          key: '',
          permi: ['community:localQualify:edit']
        },
        {
          text: '',
          handle: (row) => { this.changeStatus(row); },
          rowOptText: row => row.status === 1 ? '禁用' : '启用',
          customRender: true,
          permi: ['community:localQualify:switch']
        }
      ],
      columns: [
        {
          title: '一级类目',
          dataIndex: 'category1Name',
          align: '',
          width: '200'
        },
        {
          title: '二级类目',
          dataIndex: 'category2Name',
          align: '',
          width: '200'
        },
        {
          title: '三级类目',
          dataIndex: 'category3Name',
          align: '',
          width: '200'
        },
        {
          title: '资质要求',
          dataIndex: 'qualifyDesc',
          align: '',
          width: '200',
          scopedSlots: { customRender: 'h' }
        },
        {
          title: '状态',
          dataIndex: 'statusDesc',
          align: '',
          width: '200'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: '',
          width: '200',
          scopedSlots: { customRender: 'action' }
        }
      ],
      dataSource: [],
      searchParams: {
        categoryIds: undefined,
        status: undefined
      },

      listApi: {
        url: '/local/qualify',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      deleteParam: {
        url: '/local/qualify/',
        param: {},
        title: '行业资质',
        key: 'qualifyId'
      }
    };
  },

  created () {
    this.$get({
      url: '/local/menu/categoryTreeselect'
    }).then(res => {
      this.recursionList(res.data.menus);
      this.searchList[0].options = res.data.menus;
    });
  },
  methods: {
    recursionList (list) {
      list.forEach(item => {
        item.title = item.label;
        item.key = item.value;
        if (item.children && item.children.length) {
          this.recursionList(item.children);
        }
      });
    },
    changeStatus (row) {
      let status = row.status == 1 ? 0 : 1;
      this.$put({
        url: '/local/qualify/status/' + row.qualifyId,
        params: {status: status}
      }).then((res) => {
        this.$refs.table.getTableList();
        this.$message.success('操作成功');
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>

<style scoped>
</style>
